// src/pages/AudioAndVideoTranscription.js
import React from 'react';
import { NavLink } from 'react-router-dom';

const AudioAndVideoTranscription = () => (
  <>
    {/* Breadcrumb */}
    <div
      className="optech-breadcrumb"
      style={{ backgroundImage: "url(/assets/images/breadcrumb/breadcrumb.png)" }}
    >
      <div className="container">
        <h1 className="post__title">Audio & Video Transcription</h1>
        <nav className="breadcrumbs">
          <ul>
            <li>
              <NavLink to="/services">AI Service</NavLink>
            </li>
            <li aria-current="page">Audio & Video Transcription</li>
          </ul>
        </nav>
        <p className="text-white pt-5">
          Transcribing audio or video content into written format significantly improves accessibility, discoverability, and archival. R A Inc provides comprehensive transcription services, capturing not just the spoken words but also subtle cues that might impact context.
        </p>
      </div>
    </div>

    {/* Service Section */}
    <div className="section optech-section-padding">
      <div className="container">
        <div className="row">
          {/* Left Content Area */}
          <div className="col-lg-8">
            <div className="optech-service-details-wrap">

              {/* ←–– NEW IMAGE INSERTED HERE */}
              <img
                data-aos="fade-up"
                data-aos-duration="800"
                src="/assets/images/service/audio-video.jpg"
                alt="Audio & Video Transcription"
                className="mb-4 w-100"
              />

              {/* Overview Section */}
              <div className="optech-service-details-item">
                <h3>Overview</h3>
                <p>
                  Transcripts prove invaluable across education, legal, corporate, and media sectors. By converting spoken dialogue into text, organizations can share knowledge widely, fulfill legal obligations for documentation, and meet accessibility standards. Different levels of detail—verbatim, lightly edited, or polished—make it possible to align transcripts with the intended use, whether it’s internal review, online publication, or official record.
                </p>
              </div>

              {/* Main Services */}
              <div className="optech-service-details-item">
                <h3>Main Services</h3>
                <div className="optech-icon-list">
                  <ul>
                    <li>
                      <i className="ri-check-line" />
                      <strong>Word-for-Word (Verbatim):</strong> Preserves every spoken element, including pauses and fillers, helpful in detailed research or legal matters.
                    </li>
                    <li>
                      <i className="ri-check-line" />
                      <strong>Screened or Lightly Edited:</strong> Removes filler words and corrects minor grammatical issues, ideal for internal use.
                    </li>
                    <li>
                      <i className="ri-check-line" />
                      <strong>Intelligent (Ready-to-Publish):</strong> Creates a smooth, readable transcript for professional or public release.
                    </li>
                  </ul>
                </div>
              </div>

              {/* Matching Transcription Table */}
              <div className="optech-service-details-item">
                <h3>Matching Transcription to Use Case</h3>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Use Case</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Verbatim</td>
                      <td>Legal inquiries, qualitative research interviews</td>
                    </tr>
                    <tr>
                      <td>Screened</td>
                      <td>Team updates, managerial recaps, departmental briefings</td>
                    </tr>
                    <tr>
                      <td>Intelligent</td>
                      <td>Blog posts, external publications, official company statements</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Highlights */}
              <div className="optech-service-details-item">
                <h3>Highlights</h3>
                <ul className="list-unstyled">
                  <li><i className="ri-check-line" />We handle multi-language and multi-speaker setups, accommodating complex or group settings.</li>
                  <li><i className="ri-check-line" />Fast turnarounds are available to keep pace with urgent or time-sensitive projects.</li>
                  <li><i className="ri-check-line" />Optional timecodes and speaker identifiers simplify referencing and analysis.</li>
                </ul>
              </div>

              {/* Conclusion */}
              <div className="optech-service-details-item">
                <h3>Conclusion</h3>
                <p>
                  Whether you need a granular, word-for-word transcript or a refined, public-facing version, transcription services expand the accessibility and utility of audio/video content. R A Inc’s adaptable methods ensure your material is prepared in the most suitable style for each unique circumstance.
                </p>
              </div>
            </div>
          </div>

          {/* Sidebar Section */}
          <div className="col-lg-4">
            <div className="optech-service-sidebar">
              <div className="optech-service-menu">
                <ul>
                  {[
                    { name: 'Multimedia & DTP Services',       slug: '/multimedia-and-dtp-services' },
                    { name: 'Audio & Video Transcription',     slug: '/audio-and-video-transcription' },
                    { name: 'Desktop Publishing Services',     slug: '/desktop-publishing-services' },
                    { name: 'Subtitle Services',               slug: '/subtitling' },
                    { name: 'Multilingual Desktop Publishing', slug: '/multilingual-desktop-publishing' },
                    { name: 'Multimedia & DTP Tools',          slug: '/multimedia-and-dtp-tools' }
                  ].map(service => (
                    <li key={service.slug}>
                      <NavLink to={service.slug}>
                        {service.name} <i className="ri-arrow-right-up-line" />
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>

              <div
                className="optech-service-contact"
                data-aos="fade-up"
                data-aos-duration="800"
                style={{ backgroundImage: "url(/assets/images/service/bg.png)" }}
              >
                <div className="optech-service-contact-icon">
                  <img src="/assets/images/service/icon.svg" alt="" />
                </div>
                <h3>Need Transcription Support?</h3>
                <p>
                  Collaborate with our specialists to produce accurate, context-appropriate transcripts for legal, academic, and professional uses.
                </p>
                <NavLink className="optech-default-btn" data-text="Get in Touch" to="/contact-us">
                  <span className="btn-wraper">Get in Touch</span>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Call To Action */}
    <div
      className="section bg-cover optech-section-padding"
      style={{ backgroundImage: "url(/assets/images/cta/cta-bg2.png)" }}
    >
      <div className="container">
        <div className="optech-cta-wrap">
          <div className="optech-cta-content center">
            <h2>Let's Translate Your Vision Into Every Language</h2>
            <p>
              Whether you're expanding your business internationally or need multilingual content for local markets, we provide solutions tailored to your goals, audience, and tone.
            </p>
            <div className="optech-extra-mt" data-aos="fade-up" data-aos-duration="800">
              <NavLink className="optech-default-btn" data-text="Let’s Start a Project" to="/contact-us">
                <span className="btn-wraper">Let’s Start a Project</span>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default AudioAndVideoTranscription;